export const steps = [
  { key: "Upload", value: "Upload" },
  { key: "Extraction", value: "Extraction" },
  { key: "Merge", value: "Merge" },
  { key: "Export", value: "Export" },
];

export const acceptedFileTypes = {
  "image/png": [],
  "image/jpeg": [],
  "application/pdf": [],
};
